import { render, staticRenderFns } from "./prodDetails.vue?vue&type=template&id=06e18b0f&scoped=true&"
import script from "./prodDetails.vue?vue&type=script&lang=js&"
export * from "./prodDetails.vue?vue&type=script&lang=js&"
import style0 from "./prodDetails.vue?vue&type=style&index=0&id=06e18b0f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e18b0f",
  null
  
)

component.options.__file = "prodDetails.vue"
export default component.exports